import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Lock, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import api from '@/lib/api';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/admin/dashboard';

  useEffect(() => {
    document.title = 'Admin Login | Cespedis';
    if (localStorage.getItem('cespedis_token')) navigate('/admin/dashboard');
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { email, password });
      localStorage.setItem('cespedis_token', res.data.access_token);
      localStorage.setItem('cespedis_user', JSON.stringify(res.data.user));
      toast.success('Welcome back');
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Invalid credentials');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#144726] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <img src="/brand/cespedis-logo-md.png" alt="Cespedis" className="h-14 w-auto brightness-0 invert opacity-95" />
        </Link>

        <div className="rounded-2xl border border-white/10 bg-white p-8 shadow-2xl">
          <div className="flex h-12 w-12 items-center justify-center rounded-md bg-[#144726] text-[#C6A35B]"><Lock className="h-5 w-5" /></div>
          <h1 className="mt-5 font-display text-2xl font-semibold text-[#144726]">Sign in to Admin</h1>
          <p className="mt-1 text-sm text-slate-500">Manage properties, blog posts, and incoming leads.</p>

          <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
            <div>
              <Label htmlFor="login-email">Email</Label>
              <Input id="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@cespedis.com" data-testid="admin-login-email" required />
            </div>
            <div>
              <Label htmlFor="login-password">Password</Label>
              <Input id="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-login-password" required />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#144726] text-white hover:bg-[#0E3520]" data-testid="admin-login-submit">
              {loading ? 'Signing in…' : <>Sign in <ArrowRight className="ml-2 h-4 w-4" /></>}
            </Button>
          </form>
        </div>
        <p className="mt-6 text-center text-xs text-white/60">Default credentials: admin@cespedis.com / Cespedis@2025</p>
      </div>
    </div>
  );
}
